import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { intialPageSize } from 'constants';
import { format } from 'date-fns';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';
import { dateFnsFormat } from 'constants';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import { pageSizeChangeHandler } from 'utils/commonUtils';

const StudentDetails = () => {
  const [courseList, setCourseList] = useState({
    isLoading: false,
    rows: [],
    pageSize: intialPageSize,
    page: 1,
  });
  const { pageSize, page } = courseList;

  const courseInformation = useSelector((state) => state.studentDetails?.item);

  useEffect(() => {
    if (courseInformation) {
      fetchDataCourseInformation();
    }
  }, [pageSize, page, courseInformation]);

  const fetchDataCourseInformation = () => {
    setCourseList((previous) => ({
      ...previous,
      rows: courseInformation?.attendanceData?.courseInfo?.map(
        (item, index) => ({
          id: index,
          courseName: item.courseName,
          actualGrade: item.actualGrade,
          lastOnlineActivity: format(
            new Date(item.lastOnlineActivity),
            dateFnsFormat
          ),
          numSchoolDaysSinceOnline: item.numSchoolDaysSinceOnline,
        })
      ),
    }));
  };

  const columns = [
    {
      headerName: 'Course Name',
      field: 'courseName',
      renderCell: renderCellExpand,
      width: 500,
    },
    { headerName: 'Actual Grade', field: 'actualGrade', flex: 1 },
    {
      headerName: 'Last Online Activity',
      field: 'lastOnlineActivity',
      flex: 1,
    },
    {
      headerName: 'School Days Since Online',
      field: 'numSchoolDaysSinceOnline',
      width: 250,
      align: 'center',
    },
  ];

  const pageSizeChange = pageSizeChangeHandler(setCourseList);

  return (
    <>
      <DeltaDataGrid
        listData={courseList}
        columns={columns}
        setListData={pageSizeChange}
      />
    </>
  );
};

export default StudentDetails;
